import { Box, Button, Checkbox, CheckboxGroup, Image, Spinner } from '@chakra-ui/react'
import type { SimpleItem } from 'BrokerTsLib/src/dtos'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'
import { useContext, useEffect } from 'react'

import { getLogo } from '@/utils/companiesLogos'
import { insuranceParamsContext } from '../layouts/Wizard'
import type { ICompany } from '../utils/companies'
import { FormLabel } from './FormLabel'

interface CompanyProps extends ICompany {
  checked?: boolean
}

const CompanyCheckbox = ({ children }: any) => {
  return (
    <Box
      as="label"
      sx={{
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        px: 4,
        py: 1,
        borderRadius: 'sm',
        cursor: 'pointer',
        _hover: {
          backgroundColor: 'gray.50',
        },
      }}
    >
      {children}
    </Box>
  )
}

export const InsuranceCompanies = ({
  companies = [],
  title,
  tooltip,
  isLoadingCompanies,
  propPath,
  isDisabled = false
}
  : {
    companies: Array<ICompany | SimpleItem>,
    title?: string,
    tooltip?: string,
    isLoadingCompanies: boolean,
    propPath: string,
    isDisabled?: boolean
  }) => {
  const { control, watch, setValue } = useFormContext()
  const { insuranceParamsId: paramsId } = useContext(insuranceParamsContext)!

  const selected = watch(propPath)
  const allSelected = selected?.length === companies.length

  const toggleAll = () => {
    setValue(propPath, allSelected ? [] : companies.map(comp => comp.id))
  }

  useEffect(() => {
    if (!allSelected && companies.length > 0 && !paramsId)
      toggleAll()
  }, [paramsId, companies])

  return (
    <Box>
      <Box as="header" sx={{ display: 'flex', gap: 4, mb: 4 }}>

        <FormLabel tooltip={tooltip}>{title ?? 'Pojišťovny'}</FormLabel>

        {companies.length > 1 && !isDisabled && <Button type="button" variant="outline" size="sm" onClick={toggleAll}>
          {allSelected ? 'Zrušit výběr' : 'Vybrat vše'}
        </Button>}

        {isLoadingCompanies && <Spinner />}
      </Box>

      <Controller
        name={propPath}
        control={control}
        render={({ field: { onChange, value } }) => (
          <CheckboxGroup
            onChange={values => onChange(values.map(val => parseInt(val.toString())))}
            value={value}
            isDisabled={isDisabled}
          >
            <Box as="main" sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {companies && companies.map(({ id, name }: CompanyProps) =>
                <CompanyCheckbox key={id}>
                  <Checkbox value={id} />

                  <Image src={getLogo(id)} alt={name} title={name} width="64px" maxH="48px" />
                </CompanyCheckbox>
              )}
            </Box>
          </CheckboxGroup>
        )
        }
      />
    </Box >
  )
}
